import EligibilitySimulator from "../components/EligibilitySimulator";

export default function Simulateur() {
  return (
    <div data-testid="simulateur-page" className="pt-32 pb-24 relative overflow-hidden bg-[#050505]">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center mb-10">
        <div className="eyebrow">Simulateur d'éligibilité</div>
        <h1 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-[0.9] tracking-tight">
          Vos <span className="text-[#7DD923]">aides</span> en 2 min
        </h1>
        <p className="text-white/70 mt-4">
          MaPrimeRénov', CEE, aides locales : découvrez combien vous pouvez toucher.
        </p>
      </div>
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <EligibilitySimulator />
      </div>
    </div>
  );
}
